export default "__VITE_ASSET__6573e080__"